export const LOCATION = {
  ANY: { ID: 0 },
  MOSCOW_AND_AREA: { ID: -1 },
  SPB_AND_AREA: { ID: -2 },
  ROSTOV: { ID: 4959 },
  NOVOROSSIYSK: { ID: 4896 },
  YAROSLAVL: { ID: 5075 },
  KALUGA: { ID: 4780 },
  OBNINSK: { ID: 4908 },
  PERM: { ID: 4927 },
  EKB: { ID: 4743 },
  TYUMEN: { ID: 5024 },
  VLADIVOSTOK: { ID: 4701 },
  YUZHNOSAHALINSK: { ID: 5069 },
  NIZHNIYNOVGOROD: { ID: 4596 },
  KAZAN: { ID: 4777 },
  BLAGOVESHCHENSK: { ID: 4683 },
  KHABAROVSK: { ID: 5039 },
};

/**
 * Список регионов по порядку для дропдауна в фильтрах
 * Мск и МО, СПб, Екб, Тюмень, Ростов-на-Дону, Обнинск, Калуга, Новороссийск, Ярославль, Пермь, Владивосток, Южно-Сахалинск, Нижний Новгород
 */
export const locationsInOrder: number[] = [
  LOCATION.MOSCOW_AND_AREA.ID,
  LOCATION.SPB_AND_AREA.ID,
  LOCATION.EKB.ID,
  LOCATION.TYUMEN.ID,
  LOCATION.ROSTOV.ID,
  LOCATION.OBNINSK.ID,
  LOCATION.KALUGA.ID,
  LOCATION.NOVOROSSIYSK.ID,
  LOCATION.YAROSLAVL.ID,
  LOCATION.PERM.ID,
  LOCATION.VLADIVOSTOK.ID,
  LOCATION.YUZHNOSAHALINSK.ID,
  LOCATION.NIZHNIYNOVGOROD.ID,
  LOCATION.KAZAN.ID,
  LOCATION.BLAGOVESHCHENSK.ID,
  LOCATION.KHABAROVSK.ID,
];

export const TIMEZONE_BY_LOCATION: Record<number, number> = {
  [LOCATION.ANY.ID]: 3,
  [LOCATION.MOSCOW_AND_AREA.ID]: 3,
  [LOCATION.SPB_AND_AREA.ID]: 3,
  [LOCATION.ROSTOV.ID]: 3,
  [LOCATION.NOVOROSSIYSK.ID]: 3,
  [LOCATION.YAROSLAVL.ID]: 3,
  [LOCATION.KALUGA.ID]: 3,
  [LOCATION.OBNINSK.ID]: 3,
  [LOCATION.PERM.ID]: 5,
  [LOCATION.EKB.ID]: 5,
  [LOCATION.TYUMEN.ID]: 5,
  [LOCATION.VLADIVOSTOK.ID]: 10,
  [LOCATION.YUZHNOSAHALINSK.ID]: 11,
  [LOCATION.NIZHNIYNOVGOROD.ID]: 3,
  [LOCATION.KAZAN.ID]: 3,
  [LOCATION.BLAGOVESHCHENSK.ID]: 9,
  [LOCATION.KHABAROVSK.ID]: 10,
};
